import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { QtyInputComponent } from '../../app/content/layout/components/product/qty-input/qty-input.component';
import { withCommonDecorators } from '../_utils/story-helpers';

const meta: Meta<QtyInputComponent> = {
  title: 'Atoms/Qty Input',
  component: QtyInputComponent,
  decorators: [...withCommonDecorators()],
  parameters: {
    layout: 'centered',
    docs: {
      description: {
        component: 'Quantity input with plus/minus buttons, debounce support, and keyboard submit.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<QtyInputComponent>;

export const Default: Story = {
  args: {
    qty: 1,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('input')).toBeTruthy();
  },
};

export const HighQuantity: Story = {
  args: {
    qty: 12,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('input')).toBeTruthy();
  },
};

export const Disabled: Story = {
  args: {
    qty: 1,
    disable: true,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('input')).toBeTruthy();
  },
};

export const SmallVariant: Story = {
  args: {
    qty: 1,
    small: true,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('input')).toBeTruthy();
  },
};

export const WithDebounce: Story = {
  args: {
    qty: 1,
    enableDebounce: true,
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('input')).toBeTruthy();
  },
};
